import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {CaseProcedureConfigurationModel} from '../../models/caseProcedures/case-procedure-configuration.model';
import {CaseProcedureFormConfigurationModel} from '../../models/caseProcedures/case-procedure-form-configuration.model';

@Injectable({
  providedIn: 'root'
})
export class CaseCreateWizardService {
  constructor(private http: HttpClient) { }

  getProcedureGroup(procedureGroupID: string): Observable<CaseProcedureConfigurationModel[]> {
    return this.http.get<CaseProcedureConfigurationModel[]>(`/api/procedureGroup/${procedureGroupID}`);
  }

  getProcedureForms(caseProcedureId: string) {
    return this.http.get<CaseProcedureFormConfigurationModel[]>(`api/cases/get-procedure-forms/${caseProcedureId}`);
  }

  checkIfParentProcedure(caseProcedureId: string) {
    return this.http.get<CaseProcedureConfigurationModel[]>(`api/cases/check-if-parent-procedure/${caseProcedureId}`);
  }

  getProcedures(): Observable<any> {
    let url: string;
    let method: string = 'ApplicationProcedures';
    url = environment.TDOurl + method ;
    return this.http.get<any>(url);
  }


  saveCase(caseInfo: any): Observable<any> {
    let url: string;
    let method: string = 'SaveCaseReasonForVisit';
    url = environment.TDOurl + method ;
    return this.http.post<any>(url, caseInfo);
  }

  handleError(error) {
    console.error('patient error: ', error.message);
  }
}
